/**
 * @module Model.Event
 *
 */
import { Model } from "typedefs";

export class StudentProfileModel implements Model {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  profilePicture: string;
  calendarSubscriptionUrl: string;
  hasPurchases: boolean;
  // CN-1323: present only for managed dependents (the family head's external id),
  // so session views can tell which profile is a family member; birthdate backs
  // the "Age N" label.
  headExternalId: string | null;
  // CN-1323 (CFTB-3284): the family head's name, so an edited session can name
  // the parent in the "Paying User" note instead of falling back to a generic
  // "Parent / Guardian" (the create flow gets this from the raw picker athlete).
  headFullName: string | null;
  birthdate: string | null;

  constructor(studentProfile: any) {
    this.id = studentProfile.id;
    this.firstName = studentProfile.firstName;
    this.lastName = studentProfile.lastName;
    this.email = studentProfile.email;
    this.phone = studentProfile.phone;
    this.profilePicture = studentProfile.profilePicture;
    this.calendarSubscriptionUrl = studentProfile.calendarSubscriptionUrl;
    this.hasPurchases = studentProfile.hasPurchases;
    this.headExternalId = studentProfile.headExternalId ?? null;
    this.headFullName = studentProfile.headFullName ?? null;
    this.birthdate = studentProfile.birthdate ?? null;
  }

  public get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
}
